import React, { useEffect, useState } from 'react';
import Chapter from '../../Chapter';
import { AnimatePresence, motion } from 'framer-motion';
import { NIKE_EASE } from '../../../rise/constants/nikerise';
import ServiceHubPosterChapterData from './PosterChapter.interface';
import PosterLayout from './PosterLayout';
import { get, isNumber } from 'lodash';
import { secToMs } from '../../../core/utils/transforms';
import setAnimationTimeout from '../../../core/utils/setAnimationTimeout';
import {
    ANIMATION_IN_DURATION_S,
    ANIMATION_OUT_DURATION_S,
    QR_DURATION_S,
    STATIC_STATE_DELAY_S
} from './PosterChapter.constants';

export default class ServiceHubPosterChapter extends Chapter<ServiceHubPosterChapterData> {
    component = () => {
        const [isVisible, setIsVisible] = useState(true);

        useEffect(() => {
            const duration = secToMs(this.calculateStaticDuration() + ANIMATION_IN_DURATION_S);
            return setAnimationTimeout(() => setIsVisible(false), duration);
        }, []);

        return (
            <AnimatePresence>
                {isVisible ? (
                    <motion.div
                        key={'poster'}
                        style={{
                            position: 'absolute',
                            width: '100vw',
                            height: '100vh',
                        }}
                        initial={{ y: '100vh' }}
                        animate={{
                            y: 0,
                            transition: {
                                duration: ANIMATION_IN_DURATION_S,
                                ease: NIKE_EASE,
                            },
                        }}
                        exit={{
                            y: '-100vh',
                            transition: {
                                duration: ANIMATION_OUT_DURATION_S,
                                ease: NIKE_EASE,
                            },
                        }}
                    >
                        <PosterLayout {...this.data} />
                    </motion.div>
                ) : null}
            </AnimatePresence>
        )
    }

    fonts = ['HelveticaNowDisplay', 'HelveticaNowText'];

    calculateStaticDuration(): number {
        let duration = STATIC_STATE_DELAY_S;

        if (this.data?.media?.resource_type === 'image') {
            if (this.data?.has_qr_code) {
                duration += QR_DURATION_S;
            }

            return duration;
        } else {
            const mediaDuration = get(this.data, 'media.duration', STATIC_STATE_DELAY_S);
            if (isNumber(mediaDuration)) {
                duration = mediaDuration;
            }

            if (this.data?.has_qr_code) {
                duration = Math.max(duration, QR_DURATION_S);
            }

            return duration;
        }
    }

    calculateDuration(): number {
        if (this.data?.media?.resource_type === 'image') {
            return this.calculateStaticDuration() + ANIMATION_IN_DURATION_S + ANIMATION_OUT_DURATION_S;
        } else {
            return this.calculateStaticDuration();
        }
    }
};
